export const continents = [
  'Europe',
  'Asia',
  'North America',
  'South America',
  'Africa',
  'Oceania',
];

export const countryData = {
  ABW: { country: 'Aruba', continent: 'North America', worldAtlasName: 'Aruba' },
  AFG: { country: 'Afghanistan', continent: 'Asia', worldAtlasName: 'Afghanistan' },
  AGO: { country: 'Angola', continent: 'Africa', worldAtlasName: 'Angola' },
  ALB: { country: 'Albania', continent: 'Europe', worldAtlasName: 'Albania' },
  AND: { country: 'Andorra', continent: 'Europe', worldAtlasName: 'Andorra' },
  ARE: {
    country: 'United Arab Emirates',
    continent: 'Asia',
    worldAtlasName: 'United Arab Emirates',
  },
  ARG: {
    country: 'Argentina',
    continent: 'South America',
    worldAtlasName: 'Argentina',
  },
  ARM: { country: 'Armenia', continent: 'Asia', worldAtlasName: 'Armenia' },
  ASM: {
    country: 'American Samoa',
    continent: 'Oceania',
    worldAtlasName: 'American Samoa',
  },
  ATG: {
    country: 'Antigua and Barbuda',
    continent: 'North America',
    worldAtlasName: 'Antigua and Barb.',
  },
  AUS: { country: 'Australia', continent: 'Oceania', worldAtlasName: 'Australia' },
  AUT: { country: 'Austria', continent: 'Europe', worldAtlasName: 'Austria' },
  AZE: { country: 'Azerbaijan', continent: 'Asia', worldAtlasName: 'Azerbaijan' },
  BDI: { country: 'Burundi', continent: 'Africa', worldAtlasName: 'Burundi' },
  BEL: { country: 'Belgium', continent: 'Europe', worldAtlasName: 'Belgium' },
  BEN: { country: 'Benin', continent: 'Africa', worldAtlasName: 'Benin' },
  BFA: {
    country: 'Burkina Faso',
    continent: 'Africa',
    worldAtlasName: 'Burkina Faso',
  },
  BGD: { country: 'Bangladesh', continent: 'Asia', worldAtlasName: 'Bangladesh' },
  BGR: { country: 'Bulgaria', continent: 'Europe', worldAtlasName: 'Bulgaria' },
  BHR: { country: 'Bahrain', continent: 'Asia', worldAtlasName: 'Bahrain' },
  BHS: {
    country: 'Bahamas, The',
    continent: 'North America',
    worldAtlasName: 'Bahamas',
  },
  BIH: {
    country: 'Bosnia and Herzegovina',
    continent: 'Europe',
    worldAtlasName: 'Bosnia and Herz.',
  },
  BLR: { country: 'Belarus', continent: 'Europe', worldAtlasName: 'Belarus' },
  BLZ: { country: 'Belize', continent: 'North America', worldAtlasName: 'Belize' },
  BMU: { country: 'Bermuda', continent: 'North America', worldAtlasName: 'Bermuda' },
  BOL: { country: 'Bolivia', continent: 'South America', worldAtlasName: 'Bolivia' },
  BRA: { country: 'Brazil', continent: 'South America', worldAtlasName: 'Brazil' },
  BRB: {
    country: 'Barbados',
    continent: 'North America',
    worldAtlasName: 'Barbados',
  },
  BRN: { country: 'Brunei Darussalam', continent: 'Asia', worldAtlasName: 'Brunei' },
  BTN: { country: 'Bhutan', continent: 'Asia', worldAtlasName: 'Bhutan' },
  BWA: { country: 'Botswana', continent: 'Africa', worldAtlasName: 'Botswana' },
  CAF: {
    country: 'Central African Republic',
    continent: 'Africa',
    worldAtlasName: 'Central African Rep.',
  },
  CAN: { country: 'Canada', continent: 'North America', worldAtlasName: 'Canada' },
  CHE: {
    country: 'Switzerland',
    continent: 'Europe',
    worldAtlasName: 'Switzerland',
  },
  CHI: { country: 'Channel Islands', continent: 'Europe', worldAtlasName: '' },
  CHL: { country: 'Chile', continent: 'South America', worldAtlasName: 'Chile' },
  CHN: { country: 'China', continent: 'Asia', worldAtlasName: 'China' },
  CIV: {
    country: "Cote d'Ivoire",
    continent: 'Africa',
    worldAtlasName: "Côte d'Ivoire",
  },
  CMR: { country: 'Cameroon', continent: 'Africa', worldAtlasName: 'Cameroon' },
  COD: {
    country: 'Congo, Dem. Rep.',
    continent: 'Africa',
    worldAtlasName: 'Dem. Rep. Congo',
  },
  COG: { country: 'Congo, Rep.', continent: 'Africa', worldAtlasName: 'Congo' },
  COK: { country: 'Cook Islands', continent: 'Oceania', worldAtlasName: 'Cook Is.' },
  COL: {
    country: 'Colombia',
    continent: 'South America',
    worldAtlasName: 'Colombia',
  },
  COM: { country: 'Comoros', continent: 'Africa', worldAtlasName: 'Comoros' },
  CPV: { country: 'Cabo Verde', continent: 'Africa', worldAtlasName: 'Cabo Verde' },
  CRI: {
    country: 'Costa Rica',
    continent: 'North America',
    worldAtlasName: 'Costa Rica',
  },
  CUB: { country: 'Cuba', continent: 'North America', worldAtlasName: 'Cuba' },
  CUW: { country: 'Curacao', continent: 'North America', worldAtlasName: 'Curaçao' },
  CYM: {
    country: 'Cayman Islands',
    continent: 'North America',
    worldAtlasName: 'Cayman Is.',
  },
  CYP: { country: 'Cyprus', continent: 'Europe', worldAtlasName: 'Cyprus' },
  CZE: { country: 'Czechia', continent: 'Europe', worldAtlasName: 'Czechia' },
  DEU: { country: 'Germany', continent: 'Europe', worldAtlasName: 'Germany' },
  DJI: { country: 'Djibouti', continent: 'Africa', worldAtlasName: 'Djibouti' },
  DMA: {
    country: 'Dominica',
    continent: 'North America',
    worldAtlasName: 'Dominica',
  },
  DNK: { country: 'Denmark', continent: 'Europe', worldAtlasName: 'Denmark' },
  DOM: {
    country: 'Dominican Republic',
    continent: 'North America',
    worldAtlasName: 'Dominican Rep.',
  },
  DZA: { country: 'Algeria', continent: 'Africa', worldAtlasName: 'Algeria' },
  ECU: { country: 'Ecuador', continent: 'South America', worldAtlasName: 'Ecuador' },
  EGY: { country: 'Egypt', continent: 'Africa', worldAtlasName: 'Egypt' },
  ERI: { country: 'Eritrea', continent: 'Africa', worldAtlasName: 'Eritrea' },
  ESP: { country: 'Spain', continent: 'Europe', worldAtlasName: 'Spain' },
  EST: { country: 'Estonia', continent: 'Europe', worldAtlasName: 'Estonia' },
  ETH: { country: 'Ethiopia', continent: 'Africa', worldAtlasName: 'Ethiopia' },
  FIN: { country: 'Finland', continent: 'Europe', worldAtlasName: 'Finland' },
  FJI: { country: 'Fiji', continent: 'Oceania', worldAtlasName: 'Fiji' },
  FRA: { country: 'France', continent: 'Europe', worldAtlasName: 'France' },
  FRO: {
    country: 'Faroe Islands',
    continent: 'Europe',
    worldAtlasName: 'Faeroe Is.',
  },
  FSM: { country: 'Micronesia', continent: 'Oceania', worldAtlasName: 'Micronesia' },
  GAB: { country: 'Gabon', continent: 'Africa', worldAtlasName: 'Gabon' },
  GBR: {
    country: 'United Kingdom',
    continent: 'Europe',
    worldAtlasName: 'United Kingdom',
  },
  GEO: { country: 'Georgia', continent: 'Asia', worldAtlasName: 'Georgia' },
  GHA: { country: 'Ghana', continent: 'Africa', worldAtlasName: 'Ghana' },
  GIN: { country: 'Guinea', continent: 'Africa', worldAtlasName: 'Guinea' },
  GMB: { country: 'Gambia, The', continent: 'Africa', worldAtlasName: 'Gambia' },
  GNB: {
    country: 'Guinea-Bissau',
    continent: 'Africa',
    worldAtlasName: 'Guinea-Bissau',
  },
  GNQ: {
    country: 'Equatorial Guinea',
    continent: 'Africa',
    worldAtlasName: 'Eq. Guinea',
  },
  GRC: { country: 'Greece', continent: 'Europe', worldAtlasName: 'Greece' },
  GRD: { country: 'Grenada', continent: 'North America', worldAtlasName: 'Grenada' },
  GRL: {
    country: 'Greenland',
    continent: 'North America',
    worldAtlasName: 'Greenland',
  },
  GTM: {
    country: 'Guatemala',
    continent: 'North America',
    worldAtlasName: 'Guatemala',
  },
  GUM: { country: 'Guam', continent: 'Oceania', worldAtlasName: 'Guam' },
  GUY: { country: 'Guyana', continent: 'South America', worldAtlasName: 'Guyana' },
  HKG: { country: 'Hong Kong', continent: 'Asia', worldAtlasName: 'Hong Kong' },
  HND: {
    country: 'Honduras',
    continent: 'North America',
    worldAtlasName: 'Honduras',
  },
  HRV: { country: 'Croatia', continent: 'Europe', worldAtlasName: 'Croatia' },
  HTI: { country: 'Haiti', continent: 'North America', worldAtlasName: 'Haiti' },
  HUN: { country: 'Hungary', continent: 'Europe', worldAtlasName: 'Hungary' },
  IDN: { country: 'Indonesia', continent: 'Asia', worldAtlasName: 'Indonesia' },
  IMN: {
    country: 'Isle of Man',
    continent: 'Europe',
    worldAtlasName: 'Isle of Man',
  },
  IND: { country: 'India', continent: 'Asia', worldAtlasName: 'India' },
  IRL: { country: 'Ireland', continent: 'Europe', worldAtlasName: 'Ireland' },
  IRN: { country: 'Iran', continent: 'Asia', worldAtlasName: 'Iran' },
  IRQ: { country: 'Iraq', continent: 'Asia', worldAtlasName: 'Iraq' },
  ISL: { country: 'Iceland', continent: 'Europe', worldAtlasName: 'Iceland' },
  ISR: { country: 'Israel', continent: 'Asia', worldAtlasName: 'Israel' },
  ITA: { country: 'Italy', continent: 'Europe', worldAtlasName: 'Italy' },
  JAM: { country: 'Jamaica', continent: 'North America', worldAtlasName: 'Jamaica' },
  JOR: { country: 'Jordan', continent: 'Asia', worldAtlasName: 'Jordan' },
  JPN: { country: 'Japan', continent: 'Asia', worldAtlasName: 'Japan' },
  KAZ: { country: 'Kazakhstan', continent: 'Asia', worldAtlasName: 'Kazakhstan' },
  KEN: { country: 'Kenya', continent: 'Africa', worldAtlasName: 'Kenya' },
  KGZ: { country: 'Kyrgyzstan', continent: 'Asia', worldAtlasName: 'Kyrgyzstan' },
  KHM: { country: 'Cambodia', continent: 'Asia', worldAtlasName: 'Cambodia' },
  KIR: { country: 'Kiribati', continent: 'Oceania', worldAtlasName: 'Kiribati' },
  KNA: {
    country: 'St. Kitts and Nevis',
    continent: 'North America',
    worldAtlasName: 'St. Kitts and Nevis',
  },
  KOR: { country: 'South Korea', continent: 'Asia', worldAtlasName: 'South Korea' },
  KWT: { country: 'Kuwait', continent: 'Asia', worldAtlasName: 'Kuwait' },
  LAO: { country: 'Laos', continent: 'Asia', worldAtlasName: 'Laos' },
  LBN: { country: 'Lebanon', continent: 'Asia', worldAtlasName: 'Lebanon' },
  LBR: { country: 'Liberia', continent: 'Africa', worldAtlasName: 'Liberia' },
  LBY: { country: 'Libya', continent: 'Africa', worldAtlasName: 'Libya' },
  LCA: {
    country: 'St. Lucia',
    continent: 'North America',
    worldAtlasName: 'Saint Lucia',
  },
  LIE: {
    country: 'Liechtenstein',
    continent: 'Europe',
    worldAtlasName: 'Liechtenstein',
  },
  LKA: { country: 'Sri Lanka', continent: 'Asia', worldAtlasName: 'Sri Lanka' },
  LSO: { country: 'Lesotho', continent: 'Africa', worldAtlasName: 'Lesotho' },
  LTU: { country: 'Lithuania', continent: 'Europe', worldAtlasName: 'Lithuania' },
  LUX: { country: 'Luxembourg', continent: 'Europe', worldAtlasName: 'Luxembourg' },
  LVA: { country: 'Latvia', continent: 'Europe', worldAtlasName: 'Latvia' },
  MAC: { country: 'Macao SAR, China', continent: 'Asia', worldAtlasName: 'Macao' },
  MAF: {
    country: 'St. Martin (French part)',
    continent: 'North America',
    worldAtlasName: 'St-Martin',
  },
  MAR: { country: 'Morocco', continent: 'Africa', worldAtlasName: 'Morocco' },
  MCO: { country: 'Monaco', continent: 'Europe', worldAtlasName: 'Monaco' },
  MDA: { country: 'Moldova', continent: 'Europe', worldAtlasName: 'Moldova' },
  MDG: { country: 'Madagascar', continent: 'Africa', worldAtlasName: 'Madagascar' },
  MDV: { country: 'Maldives', continent: 'Asia', worldAtlasName: 'Maldives' },
  MEX: { country: 'Mexico', continent: 'North America', worldAtlasName: 'Mexico' },
  MHL: {
    country: 'Marshall Islands',
    continent: 'Oceania',
    worldAtlasName: 'Marshall Is.',
  },
  MKD: {
    country: 'North Macedonia',
    continent: 'Europe',
    worldAtlasName: 'North Macedonia',
  },
  MLI: { country: 'Mali', continent: 'Africa', worldAtlasName: 'Mali' },
  MLT: { country: 'Malta', continent: 'Europe', worldAtlasName: 'Malta' },
  MMR: { country: 'Myanmar', continent: 'Asia', worldAtlasName: 'Myanmar' },
  MNE: { country: 'Montenegro', continent: 'Europe', worldAtlasName: 'Montenegro' },
  MNG: { country: 'Mongolia', continent: 'Asia', worldAtlasName: 'Mongolia' },
  MNP: {
    country: 'Northern Mariana Islands',
    continent: 'Oceania',
    worldAtlasName: 'N. Mariana Is.',
  },
  MOZ: { country: 'Mozambique', continent: 'Africa', worldAtlasName: 'Mozambique' },
  MRT: { country: 'Mauritania', continent: 'Africa', worldAtlasName: 'Mauritania' },
  MUS: { country: 'Mauritius', continent: 'Africa', worldAtlasName: 'Mauritius' },
  MWI: { country: 'Malawi', continent: 'Africa', worldAtlasName: 'Malawi' },
  MYS: { country: 'Malaysia', continent: 'Asia', worldAtlasName: 'Malaysia' },
  NAM: { country: 'Namibia', continent: 'Africa', worldAtlasName: 'Namibia' },
  NCL: {
    country: 'New Caledonia',
    continent: 'Oceania',
    worldAtlasName: 'New Caledonia',
  },
  NER: { country: 'Niger', continent: 'Africa', worldAtlasName: 'Niger' },
  NGA: { country: 'Nigeria', continent: 'Africa', worldAtlasName: 'Nigeria' },
  NIC: {
    country: 'Nicaragua',
    continent: 'North America',
    worldAtlasName: 'Nicaragua',
  },
  NIU: { country: 'Niue', continent: 'Oceania', worldAtlasName: 'Niue' },
  NLD: {
    country: 'Netherlands',
    continent: 'Europe',
    worldAtlasName: 'Netherlands',
  },
  NOR: { country: 'Norway', continent: 'Europe', worldAtlasName: 'Norway' },
  NPL: { country: 'Nepal', continent: 'Asia', worldAtlasName: 'Nepal' },
  NRU: { country: 'Nauru', continent: 'Oceania', worldAtlasName: 'Nauru' },
  NZL: {
    country: 'New Zealand',
    continent: 'Oceania',
    worldAtlasName: 'New Zealand',
  },
  OMN: { country: 'Oman', continent: 'Asia', worldAtlasName: 'Oman' },
  PAK: { country: 'Pakistan', continent: 'Asia', worldAtlasName: 'Pakistan' },
  PAN: { country: 'Panama', continent: 'North America', worldAtlasName: 'Panama' },
  PER: { country: 'Peru', continent: 'South America', worldAtlasName: 'Peru' },
  PHL: { country: 'Philippines', continent: 'Asia', worldAtlasName: 'Philippines' },
  PLW: { country: 'Palau', continent: 'Oceania', worldAtlasName: 'Palau' },
  PNG: {
    country: 'Papua New Guinea',
    continent: 'Oceania',
    worldAtlasName: 'Papua New Guinea',
  },
  POL: { country: 'Poland', continent: 'Europe', worldAtlasName: 'Poland' },
  PRI: {
    country: 'Puerto Rico',
    continent: 'North America',
    worldAtlasName: 'Puerto Rico',
  },
  PRK: { country: 'North Korea', continent: 'Asia', worldAtlasName: 'North Korea' },
  PRT: { country: 'Portugal', continent: 'Europe', worldAtlasName: 'Portugal' },
  PRY: {
    country: 'Paraguay',
    continent: 'South America',
    worldAtlasName: 'Paraguay',
  },
  PSE: { country: 'Palestine', continent: 'Asia', worldAtlasName: 'Palestine' },
  PYF: {
    country: 'French Polynesia',
    continent: 'Oceania',
    worldAtlasName: 'Fr. Polynesia',
  },
  QAT: { country: 'Qatar', continent: 'Asia', worldAtlasName: 'Qatar' },
  ROU: { country: 'Romania', continent: 'Europe', worldAtlasName: 'Romania' },
  RUS: { country: 'Russia', continent: 'Europe', worldAtlasName: 'Russia' },
  RWA: { country: 'Rwanda', continent: 'Africa', worldAtlasName: 'Rwanda' },
  SAU: {
    country: 'Saudi Arabia',
    continent: 'Asia',
    worldAtlasName: 'Saudi Arabia',
  },
  SDN: { country: 'Sudan', continent: 'Africa', worldAtlasName: 'Sudan' },
  SEN: { country: 'Senegal', continent: 'Africa', worldAtlasName: 'Senegal' },
  SGP: { country: 'Singapore', continent: 'Asia', worldAtlasName: 'Singapore' },
  SLB: {
    country: 'Solomon Islands',
    continent: 'Oceania',
    worldAtlasName: 'Solomon Is.',
  },
  SLE: {
    country: 'Sierra Leone',
    continent: 'Africa',
    worldAtlasName: 'Sierra Leone',
  },
  SLV: {
    country: 'El Salvador',
    continent: 'North America',
    worldAtlasName: 'El Salvador',
  },
  SMR: { country: 'San Marino', continent: 'Europe', worldAtlasName: 'San Marino' },
  SOM: { country: 'Somalia', continent: 'Africa', worldAtlasName: 'Somalia' },
  SRB: { country: 'Serbia', continent: 'Europe', worldAtlasName: 'Serbia' },
  STP: {
    country: 'Sao Tome and Principe',
    continent: 'Africa',
    worldAtlasName: 'São Tomé and Principe',
  },
  SUR: {
    country: 'Suriname',
    continent: 'South America',
    worldAtlasName: 'Suriname',
  },
  SSD: { country: 'South Sudan', continent: 'Africa', worldAtlasName: 'S. Sudan' },
  SVK: { country: 'Slovakia', continent: 'Europe', worldAtlasName: 'Slovakia' },
  SVN: { country: 'Slovenia', continent: 'Europe', worldAtlasName: 'Slovenia' },
  SWE: { country: 'Sweden', continent: 'Europe', worldAtlasName: 'Sweden' },
  SWZ: { country: 'Eswatini', continent: 'Africa', worldAtlasName: 'eSwatini' },
  SXM: {
    country: 'Sint Maarten (Dutch part)',
    continent: 'North America',
    worldAtlasName: 'Sint Maarten',
  },
  SYC: { country: 'Seychelles', continent: 'Africa', worldAtlasName: 'Seychelles' },
  SYR: { country: 'Syria', continent: 'Asia', worldAtlasName: 'Syria' },
  TCA: {
    country: 'Turks and Caicos Islands',
    continent: 'North America',
    worldAtlasName: 'Turks and Caicos Is.',
  },
  TCD: { country: 'Chad', continent: 'Africa', worldAtlasName: 'Chad' },
  TGO: { country: 'Togo', continent: 'Africa', worldAtlasName: 'Togo' },
  THA: { country: 'Thailand', continent: 'Asia', worldAtlasName: 'Thailand' },
  TJK: { country: 'Tajikistan', continent: 'Asia', worldAtlasName: 'Tajikistan' },
  TKL: { country: 'Tokelau', continent: 'Oceania', worldAtlasName: '' },
  TKM: {
    country: 'Turkmenistan',
    continent: 'Asia',
    worldAtlasName: 'Turkmenistan',
  },
  TLS: { country: 'Timor-Leste', continent: 'Asia', worldAtlasName: 'Timor-Leste' },
  TON: { country: 'Tonga', continent: 'Oceania', worldAtlasName: 'Tonga' },
  TTO: {
    country: 'Trinidad and Tobago',
    continent: 'North America',
    worldAtlasName: 'Trinidad and Tobago',
  },
  TUN: { country: 'Tunisia', continent: 'Africa', worldAtlasName: 'Tunisia' },
  TUR: { country: 'Turkiye', continent: 'Asia', worldAtlasName: 'Turkey' },
  TUV: { country: 'Tuvalu', continent: 'Oceania', worldAtlasName: 'Tuvalu' },
  TWN: { country: 'Taiwan', continent: 'Asia', worldAtlasName: 'Taiwan' },
  TZA: { country: 'Tanzania', continent: 'Africa', worldAtlasName: 'Tanzania' },
  UGA: { country: 'Uganda', continent: 'Africa', worldAtlasName: 'Uganda' },
  UKR: { country: 'Ukraine', continent: 'Europe', worldAtlasName: 'Ukraine' },
  URY: { country: 'Uruguay', continent: 'South America', worldAtlasName: 'Uruguay' },
  USA: {
    country: 'United States',
    continent: 'North America',
    worldAtlasName: 'United States of America',
  },
  UZB: { country: 'Uzbekistan', continent: 'Asia', worldAtlasName: 'Uzbekistan' },
  VCT: {
    country: 'St. Vincent and the Grenadines',
    continent: 'North America',
    worldAtlasName: 'St. Vin. and Gren.',
  },
  VEN: {
    country: 'Venezuela',
    continent: 'South America',
    worldAtlasName: 'Venezuela',
  },
  VIR: {
    country: 'Virgin Islands (U.S.)',
    continent: 'North America',
    worldAtlasName: 'U.S. Virgin Is.',
  },
  VNM: { country: 'Viet Nam', continent: 'Asia', worldAtlasName: 'Vietnam' },
  VUT: { country: 'Vanuatu', continent: 'Oceania', worldAtlasName: 'Vanuatu' },
  WSM: { country: 'Samoa', continent: 'Oceania', worldAtlasName: 'Samoa' },
  XKX: { country: 'Kosovo', continent: 'Europe', worldAtlasName: 'Kosovo' },
  YEM: { country: 'Yemen, Rep.', continent: 'Asia', worldAtlasName: 'Yemen' },
  ZAF: {
    country: 'South Africa',
    continent: 'Africa',
    worldAtlasName: 'South Africa',
  },
  ZMB: { country: 'Zambia', continent: 'Africa', worldAtlasName: 'Zambia' },
  ZWE: { country: 'Zimbabwe', continent: 'Africa', worldAtlasName: 'Zimbabwe' },
};

export const countriesInContinent = Object.entries(countryData).reduce(
  (acc, [code, { continent }]) => ({
    ...acc,
    [continent]: [...(acc[continent] ?? []), code],
  }),
  {},
);

export function withCountryCodeAsName(geoData) {
  const nameToCode = Object.fromEntries(
    Object.entries(countryData).map(([code, { worldAtlasName }]) => [
      worldAtlasName,
      code,
    ]),
  );

  // Seems like our world in data does not distinguish Somalia and Somaliland, but GeoJSON does.
  nameToCode.Somaliland = 'SOM';

  return {
    ...geoData,
    features: geoData.features.map((feature) => {
      const name = feature.properties?.name;
      const code = nameToCode[name];
      if (code === undefined) {
        return feature;
      }
      return {
        ...feature,
        properties: {
          ...feature.properties,
          name: code,
        },
      };
    }),
  };
}

export const withCountyCodeAsName = Object.entries(countryData).reduce(
  (acc, [code, { continent }]) => ({
    ...acc,
    [continent]: [...(acc[continent] ?? []), code],
  }),
  {},
);

export const oecdCountries = [
  'AUS',
  'AUT',
  'BEL',
  'CAN',
  'CHL',
  'COL',
  'CRI',
  'CZE',
  'DNK',
  'EST',
  'FIN',
  'FRA',
  'DEU',
  'GRC',
  'HUN',
  'ISL',
  'IRL',
  'ISR',
  'ITA',
  'JPN',
  'KOR',
  'LVA',
  'LTU',
  'LUX',
  'MEX',
  'NLD',
  'NZL',
  'NOR',
  'POL',
  'PRT',
  'SVK',
  'SVN',
  'ESP',
  'SWE',
  'CHE',
  'TUR',
  'GBR',
  'USA',
];

export const EU_COUNTRIES = [
  'AUT',
  'BEL',
  'BGR',
  'CYP',
  'CZE',
  'DEU',
  'DNK',
  'ESP',
  'EST',
  'FIN',
  'FRA',
  'GRC',
  'HRV',
  'HUN',
  'IRL',
  'ITA',
  'LTU',
  'LUX',
  'LVA',
  'MLT',
  'NLD',
  'POL',
  'PRT',
  'ROU',
  'SVK',
  'SVN',
  'SWE',
];

export const flags = {
  BEL: '🇧🇪',
  CHE: '🇨🇭',
  DEU: '🇩🇪',
  DNK: '🇩🇰',
  ESP: '🇪🇸',
  FRA: '🇫🇷',
  ITA: '🇮🇹',
  NOR: '🇳🇴',
  POL: '🇵🇱',
  PRT: '🇵🇹',
  SWE: '🇸🇪',
};
